import { Routes } from '@angular/router';
import { environment } from '@env/environment';
import { AuthGuard } from './guards/auth.guard';
import { HomePagesComponent } from './pages/home-pages/home-pages.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

// Dove l'applicazione e' pubblica si entra direttamente nella dashboard.
// Mandare comunque su /login non basterebbe a disattivare l'autenticazione:
// LoginComponent chiama signIn() in ngOnInit, quindi la visita partirebbe
// ugualmente con un redirect verso il portale ArcGIS.
const landingRoute = environment.auth.required ? 'auth/login' : 'dashboard';

export const routes: Routes = [
  // redirect iniziale
  { path: '', redirectTo: landingRoute, pathMatch: 'full' },

  {
    path: 'auth/login',
    loadComponent: () =>
      import('./authentication/login/login').then(
        (m) => m.LoginComponent
      ),
  },

  // rotte protette
  {
    path: '',
    component: HomePagesComponent,
    children: [
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadComponent: () =>
          import('../app/components/map/map.component').then(
            (m) => m.MapComponent
          ),
      },
    ],
  },

  { path: 'unauthorized', component: UnauthorizedComponent },

  { path: '**', redirectTo: landingRoute },
];
